module.exports = __webpack_public_path__ + "img/cause2Orange.0c674aa7.png";